// extracted by mini-css-extract-plugin
export default {"familyStatusButtonBox":"FamilyStatus_familyStatusButtonBox__6I1S+"};